import { render, staticRenderFns } from "./FamilyFilter.vue?vue&type=template&id=a70354be&"
import script from "./FamilyFilter.vue?vue&type=script&lang=js&"
export * from "./FamilyFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports